import React, { useState } from 'react';

const LudoGame: React.FC = () => {
  const [leaderboardConfig, setLeaderboardConfig] = useState({
    "id": "ludo_leaderboard",
    "authoritative": true,
    "sort_order": "desc",
    "operator": "best",
    "reset_schedule": "0 0 * * 0",
    "metadata": {
      "game": "ludo",
      "description": "Ludo game leaderboard",
      "reward_tiers": {
        "1": { "coins": 100, "title": "Ludo Champion" },
        "2": { "coins": 75, "title": "Ludo Master" },
        "3": { "coins": 50, "title": "Ludo Expert" }
      },
      "season_duration": "weekly",
      "min_games_required": 5
    }
  });

  const [jsonError, setJsonError] = useState<string | null>(null);
  const [isEditing, setIsEditing] = useState(false);

  const handleJsonChange = (value: string) => {
    try {
      const parsed = JSON.parse(value);
      setLeaderboardConfig(parsed);
      setJsonError(null);
    } catch (error) {
      setJsonError('Invalid JSON format');
    }
  };

  const saveLeaderboardConfig = () => {
    // Here you would typically save to your backend
    console.log('Saving Ludo leaderboard config:', leaderboardConfig);
    setIsEditing(false);
    alert('Leaderboard configuration saved successfully!');
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h1>🎲 Ludo Game</h1>
        <p>Welcome to the Ludo game interface!</p>
        <p>This is where the Ludo game would be embedded or managed.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', alignItems: 'start' }}>
        {/* Game Features */}
        <div style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
        }}>
          <h2>Game Features</h2>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li>🎮 Multiplayer Support</li>
            <li>🤖 AI Opponents</li>
            <li>👥 Pass & Play Mode</li>
            <li>👫 Friends Mode</li>
            <li>🏆 Leaderboards</li>
            <li>🪙 Coin Rewards</li>
          </ul>
        </div>

        {/* Leaderboard Configuration */}
        <div style={{
          background: 'white',
          border: '1px solid #e9ecef',
          borderRadius: '12px',
          padding: '2rem',
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h2 style={{ margin: 0, color: '#333' }}>🏆 Leaderboard Configuration</h2>
            <button
              onClick={() => setIsEditing(!isEditing)}
              style={{
                background: isEditing ? '#dc3545' : '#667eea',
                color: 'white',
                border: 'none',
                padding: '0.5rem 1rem',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '0.9rem'
              }}
            >
              {isEditing ? 'Cancel' : 'Edit'}
            </button>
          </div>

          {isEditing ? (
            <div>
              <textarea
                value={JSON.stringify(leaderboardConfig, null, 2)}
                onChange={(e) => handleJsonChange(e.target.value)}
                style={{
                  width: '100%',
                  height: '400px',
                  fontFamily: 'Monaco, Consolas, monospace',
                  fontSize: '0.85rem',
                  padding: '1rem',
                  border: jsonError ? '2px solid #dc3545' : '1px solid #ced4da',
                  borderRadius: '6px',
                  resize: 'vertical'
                }}
                placeholder="Enter leaderboard configuration JSON..."
              />
              {jsonError && (
                <div style={{ color: '#dc3545', fontSize: '0.85rem', marginTop: '0.5rem' }}>
                  {jsonError}
                </div>
              )}
              <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
                <button
                  onClick={saveLeaderboardConfig}
                  disabled={!!jsonError}
                  style={{
                    background: jsonError ? '#6c757d' : '#28a745',
                    color: 'white',
                    border: 'none',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '6px',
                    cursor: jsonError ? 'not-allowed' : 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  Save Configuration
                </button>
              </div>
            </div>
          ) : (
            <div>
              <div style={{ marginBottom: '1rem' }}>
                <strong>Leaderboard ID:</strong> {leaderboardConfig.id}
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <strong>Type:</strong> {leaderboardConfig.authoritative ? 'Authoritative' : 'Client'}
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <strong>Sort Order:</strong> {leaderboardConfig.sort_order.toUpperCase()}
              </div>
              <pre style={{
                background: '#f8f9fa',
                padding: '1rem',
                borderRadius: '6px',
                fontSize: '0.8rem',
                overflow: 'auto',
                maxHeight: '300px',
                border: '1px solid #e9ecef'
              }}>
                {JSON.stringify(leaderboardConfig, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LudoGame;
